// Build the "listen" text for TTS. Skips URLs/sources & bullet symbols.
const DISCLAIMER =
  "Ces informations sont générales et ne remplacent pas l'avis de votre équipe médicale.";
const PREMA_URGENCE = "En cas de détresse : le 3114, disponible 24 heures sur 24.";

function endWithStop(line) {
  const t = (line || "").trim();
  if (!t) return "";
  return /[.!?…»)]$/.test(t) ? t : t + ".";
}

function cleanContent(content) {
  const out = [];
  for (const rawLine of (content || "").split("\n")) {
    let line = rawLine.trim();
    if (!line) continue;
    if (line.startsWith("## ")) line = line.slice(3);
    else if (line.startsWith("> ")) line = line.slice(2);
    else if (line.startsWith("• ")) line = line.slice(2);
    line = line.replace(/\*\*/g, "");
    out.push(endWithStop(line));
  }
  return out.join("\n");
}

export function buildReadingText(item, { isPrema = false, phaseLabel = "" } = {}) {
  const parts = [];
  parts.push(endWithStop(item.title));
  const meta = `${phaseLabel || item.category} · ${item.read_time || ""}`.trim();
  parts.push(endWithStop(meta));
  parts.push(cleanContent(item.content));
  parts.push(DISCLAIMER);
  if (isPrema) parts.push(PREMA_URGENCE);
  return parts.filter(Boolean).join("\n");
}
